<template>
	<div :class="$style['products__root-row']">
		<RowSkeleton v-if="requesting" :columns="columns" />
		<BaseTableRow
			v-if="!requesting && !!product"
			:class="$style['products__row']"
			:value="product.id"
			:show-checkbox="false"
		>
			<BaseTableCol width-preset="media">
				<div :class="$style['oem-product']">
					<div :class="$style['oem-product__info']">
						<div
							:class="[$style['image-wrappper'], {
								[$style['image-wrappper--openable']]: product.logoUrl && !picturesLoading
							}]"
							@click.stop="handleOpenGallery(product.id)"
						>
							<img
								v-if="product.logoUrl"
								alt="logo"
								:src="product.logoUrl"
							/>
							<FontAwesomeIcon
								v-else
								:icon="['fal', 'image']"
								:class="$style['image-wrappper-placeholder']"
							/>
							<!-- <div
                v-if="picturesLoading"
                :class="$style['image-wrappper__spinner']"
              >
                <Spinner width="40px" />
              </div>
              <FontAwesomeIcon
                v-else
                :icon="['far', 'search-plus']"
                :class="$style['image-wrappper__icon']"
              /> -->
						</div>
						<div :class="$style['oem-product__attributes']">
							<div :class="$style['oem-product__title']">
								<RouterLink
									v-if="productName && product.recarId"
									:to="{ name: 'Dashboard:Part', params: { id: product.recarId } }"
									:class="$style['oem-product__title-link']"
								>
									<strong>{{ productName }}</strong>
								</RouterLink>
								<strong v-else-if="productName">{{ productName }}</strong>
							</div>
							<small
								v-if="product.oemCode"
								:class="$style['oem-product__detail']"
							>
								{{ product.oemCode }}
							</small>
							<small
								v-if="product.parameters && (product.name || product.title)"
								:class="$style['oem-product__detail']"
							>
								{{ product.parameters }}
							</small>
							<small
								v-if="product.subparameters"
								:class="$style['oem-product__detail']"
							>
								{{ product.subparameters }}
							</small>
							<small
								v-if="product.recarId"
								:class="$style['oem-product__detail']"
							>
								#{{ product.recarId }}
							</small>
							<RouterLink
								v-if="productSupplier && product.supplierId"
								:to="{ name: 'Dashboard:Supplier', params: { id: product.supplierId } }"
								:class="$style['oem-product__supplier']"
							>
								{{ productSupplier }}
							</RouterLink>
							<span
								v-else-if="productSupplier"
								:class="$style['oem-product__supplier']"
							>
								{{ productSupplier }}
							</span>
							<div :class="$style['oem-product__price']">
								{{ product.sellPrice | currency($auth().currency) }}
							</div>
						</div>
					</div>
					<div :class="$style['oem-product__actions']">
						<BaseQuantitySelect
							v-if="product.productType !== 'part'"
							:value="quantityLocal"
							:loading="updateLoading"
							:max-val="product.quantity"
							@input="handleUpdateQuantity"
						/>
						<span v-else>
							{{ product.quantity }} {{ $t('common.fields.units') }}
						</span>
						<BaseIconButton
							@click.stop="handleDeleteProduct()"
						>
							<FontAwesomeIcon :icon="['fal', 'trash']" />
						</BaseIconButton>
					</div>
				</div>
			</BaseTableCol>
		</BaseTableRow>
	</div>
</template>
<script>
import RowSkeleton from './RowSkeleton'
// import Spinner from '@c:essentials/Spinner'

export default {
	name: 'OemPartRow',
	components: {
		RowSkeleton
		// Spinner
	},
	props: {
		product: {
			type: Object,
			required: true
		},
		columns: {
			type: Array,
			default: () => []
		},
		requesting: {
			type: Boolean,
			default: false
		},
		deleteFunc: {
			type: Function,
			required: true
		},
		updateFunc: {
			type: Function,
			required: true
		},
		checked: {
			type: [Boolean, String],
			default: false
		}
	},
	data () {
		return {
			picturesLoading: false,
			updateLoading: false,
			addToCartLoading: false,
			quantityLocal: this.product.quantity
		}
	},
	computed: {
		productName () {
			return this.product.name || this.product.title || this.product.parameters || null
		},

		productSupplier () {
			return this.product.supplierName || this.product.supplier || null
		}
	},
	methods: {

		async handleOpenGallery (_id) {
			// this.$emit('open-gallery', this.pictures.map(picture => {
			// 	return {
			// 		id: picture.id,
			// 		src: picture.optimized,
			// 		thumbnail: picture.s195x130
			// 	}
			// }))

		},

		async handleUpdateQuantity (quantity) {
			const backupQuantity = this.quantityLocal
			this.quantityLocal = quantity
			this.updateLoading = true

			try {
				await this.updateFunc({
					...this.product,
					quantity
				})
				this.updateLoading = false
			} catch (e) {
				this.$store.dispatch(
					'Notification/ADD_ERROR_NOTIFICATION',
					e
				)
				this.quantityLocal = backupQuantity
				this.updateLoading = false
			}

		},

		async handleDeleteProduct () {
			try {
				await this.deleteFunc(this.product)
			} catch (e) {
				this.$store.dispatch(
					'Notification/ADD_ERROR_NOTIFICATION',
					e
				)
			}

		},

		handleRowClick () {
			this.$router.push({
				name: 'Dashboard:Part',
				params: { id: this.product.recarId || this.product.id }
			}).catch(_e => {})
		}
	}
}
</script>
<style lang="scss" module>

.loader {
    color: getColor(primary);
    margin-top: $gutter;
    font-size: 20px;
    animation: rotator 1.4s linear infinite;
}

.oem-product {
    display: flex;
    justify-content: space-between;
    width: 100%;

    &__info {
        display: flex;
    }

    &__actions {
        display: flex;
        align-items: center;
        gap: $gutter;
        margin-left: $gutter;
    }

    &__action {
        color: getColor(primary);
        text-decoration: none;
        font-size: 14px;
        background-color: transparent;
        border: 0;
        outline: 0;
        margin: 0;
        margin-top: $gutter;
        padding: 0;
        cursor: pointer;

        &:hover {
            color: getColor(primary-hover);
        }
    }

    &__attributes {
        display: flex;
        flex-direction: column;
        gap: calc($gutter / 2);
    }

    &__title {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: calc($gutter / 2);
        min-width: 0;

        a {
            color: getColor(text);
            text-decoration: none;

            &:hover {
                color: getColor(tertiary);
            }
        }
    }

    &__detail {
        color: getColor(sub-text);
        font-size: 14px;
        line-height: 1.3;
    }

    &__supplier {
        color: getColor(tertiary);
        text-decoration: none;
        font-size: 14px;

        &:hover {
            text-decoration: underline;
        }
    }

    &__price {
        margin-top: auto;
    }
}

.products {
    &__spinner {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 20px 0 !important;
    }
}

.image-wrappper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    min-width: 90px;
    height: 70px;
    margin-right: 15px;
    overflow: hidden;
    border-radius: 5px;
    position: relative;
    background-color: getColor(surface-overlay);
    border: 1px solid getColor(border);
    transition: border-color 0.15s ease;

    img {
        height: 100%;
        width: auto;
    }

    &--openable {
        cursor: pointer;
    }
}

.image-wrappper-placeholder {
    color: getColor(disabled-text);
    font-size: 24px;
}

.column-flex {
    display: flex;
    flex-direction: column;
}

.icon {
    margin-right: 10px;
    font-size: 16px;
    height: 20px;
    width: 20px;

    &--red {
        color: getColor(danger);
    }
}

@keyframes rotator {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(270deg);
    }
}
</style>
